<div class="bg-grey py-5">
  <section>
    <div class="container-fluid pr-lg-0">
      <div class="row mr-lg-0">
        <div class="offset-xl-1 col-xs-12 col-md-11 col-xl-5 d-flex align-items-center">
          <div>
            <h2>Get paid on time.</h2>
            <h2>Every time.</h2>
            <p class="mt-3 subhead-2 text-grey">
              We guarantee that you’ll get paid for every rental. When your machines get rented, money will be deposited into your account every month, plain
              and simple.
            </p>
            <a [routerLink]="['/signup']" [queryParams]="{ capability: 'owner' }" [skipLocationChange]="true">Get Started</a>
          </div>
        </div>
        <div class="col-xl-6 get-paid-background"></div>
      </div>
    </div>
  </section>
</div>
